import styled from 'styled-components';

export const Container = styled.div`
    position: absolute;
    border-radius: 4px 4px 0px 0px;
    background: rgb(62, 61, 64);
`;

export const Time = styled.p`
    margin: 0 8px;
    color: ${({ theme }) => theme?.color?.textPrimary || 'white'};
`;
